import { SpotStatus, type RoomLayoutSpot } from './RoomLayoutMap.types';
import { resolveSpotKeyInLayout, spotMatchesKey } from './spotKey';

/** Applies the same reserved/assigned overlays as {@link RoomLayoutMap} `spotsToShow`. */
export function applySpotsOverlayForMap(
  layoutSpots: RoomLayoutSpot[],
  reservedSpotKeys?: string[],
  assignedSpotKey?: string | null
): RoomLayoutSpot[] {
  if (!layoutSpots.length) return [];

  const resolvedAssignedSpotKey = resolveSpotKeyInLayout(layoutSpots, assignedSpotKey ?? null);
  const ids = reservedSpotKeys ?? [];
  const reservedSet = ids.length > 0 ? new Set(ids.map((id) => String(id))) : null;

  return layoutSpots.map((spot) => {
    const isMemberAssignment =
      resolvedAssignedSpotKey !== null && spotMatchesKey(spot, resolvedAssignedSpotKey);
    if (isMemberAssignment && spot.status === SpotStatus.BLOCKED) {
      return { ...spot, status: SpotStatus.BOOKABLE };
    }
    if (!reservedSet) return spot;
    const isReserved = reservedSet.has(spot.spotName) || reservedSet.has(spot.spot_name);
    if (isReserved && !isMemberAssignment && spot.status === SpotStatus.BOOKABLE) {
      return { ...spot, status: SpotStatus.BLOCKED };
    }
    return spot;
  });
}
